import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "cancel-section mt-2"
}
const _hoisted_2 = { class: "section-card cancel-card" }
const _hoisted_3 = {
  key: 0,
  class: "cancel-reason"
}
const _hoisted_4 = { class: "cancel-reason-text" }
const _hoisted_5 = { class: "cancel-actions" }

import { computed } from "vue";
import { useModalStore } from "@/shared/stores/modal";
import AppButtonFlat from "@/shared/components/ui/AppButtonFlat.vue";
import AppointmentCancellationActionModal from "@/modules/vendor/components/AppointmentCancellationActionModal.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AppointmentCancellationRequestCard',
  props: {
    appointment: {}
  },
  setup(__props: any) {

const props = __props;

const modal = useModalStore();
const hasRequest = computed(() => Boolean(props.appointment?.cancellation_request?.is_requested));
const reason = computed(() => props.appointment?.cancellation_request?.reason || "");

function handleOpenActionModal() {
  modal.open(
    AppointmentCancellationActionModal,
    {
      appointment: props.appointment,
    },
    { title: "Cancellation Options", showHeader: false, fullscreen: true },
  );
}

return (_ctx: any,_cache: any) => {
  return (hasRequest.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "px-2" }, [
          _createElementVNode("p", { class: "cancel-section-title" }, "Cancellation Request")
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          (reason.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _cache[0] || (_cache[0] = _createElementVNode("p", { class: "cancel-reason-label" }, "Reason", -1)),
                _createElementVNode("p", _hoisted_4, _toDisplayString(reason.value), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(AppButtonFlat, {
              block: "",
              color: "error",
              "prepend-icon": "mdi-cog-outline",
              onClick: handleOpenActionModal
            }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode(" Review cancellation ", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})